export class HttpBodyRespModel<T = any> {
	public totalRecord: number;
	public pageTotal: number;
	public pageSize?: number;
	public message: string;
	public data: T;
	public status: number;

	public convert(dto: Record<string, any>): HttpBodyRespModel<T> {
		this.totalRecord = dto.totalRecord;
		this.pageTotal = dto.pageTotal;
		this.pageSize = dto.pageSize;
		this.message = dto.message;
		this.data = dto.data;
		this.status = dto.status;

		return this;
	}
}
